export default "/img/GQ.4e11d0ada0f43c6f1c81b7dc21056609.png";